import React, { useContext } from "react";

import { Headline } from "../../components/Headline";
import { SectionContainer } from "../../components/SectionContainer";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";
import { ImageWithGrid } from "../../components/Image";
import { Tagline } from "../../components/Tagline/Tagline";

import ElementContext from "../../components/ElementContext";
import { generateClassString as gcs } from "../../lib/helper/generateClassString";

import * as styles from "./component.module.less";

import {
    useIsTiny,
    useIsSmaller1400,
    useIsHuge,
    useIsDesktop
} from "../../lib/hooks/mediaQueries";
import GeneralPageContext from "../../templates/GeneralPageContext";

function CallToAction({
    data: {
        anker,
        headline,
        semanticOfHeadline,
        tagline,
        ctaButton,
        background,
        subheadline,
        locale,
        image
    },
    type
}) {
    const isTiny = useIsTiny();
    const isSmaller1400 = useIsSmaller1400();
    const isHuge = useIsHuge();
    const isSmaller1200 = useIsDesktop();

    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);

    // prettier-ignore
    const gridSize = showAnchorNavigation ? (isSmaller1400 ? "M" : "L") : (isTiny ? "S" : (isSmaller1200 ? "M" : (isSmaller1400 ? "L" : (isHuge ? "XL" : "L"))));

    const { isLightBg } = useContext(ElementContext);

    return (
        <SectionContainer
            sectionId={anker}
            sectionClass={styles.ctaSection}
            containerClass={gcs(styles.ctaContainer, [
                showAnchorNavigation,
                styles.anchored
            ])}
            background={background}
        >
            <div className={styles.ctaTextContainer}>
                <div className={styles.ctaHeadline}>
                    <Tagline>{tagline}</Tagline>

                    <Headline semanticOfHeadline={semanticOfHeadline}>
                        {headline}
                    </Headline>
                </div>

                <div
                    className={gcs(
                        styles.subHeadline,
                        !isLightBg ? styles.lightColor : ""
                    )}
                >
                    <StructuredTextRenderer
                        data={subheadline}
                        contentElementType={type}
                    />
                </div>

                <div className={styles.ctaButtonContainer}>
                    <StructuredTextRenderer
                        data={ctaButton}
                        locale={locale}
                        itemLinkClass={styles.ctaLink}
                        itemLinkType={"cta"}
                        contentElementType={type}
                    />
                </div>
            </div>

            <div className={styles.ctaImageContainer}>
                <ImageWithGrid
                    className={styles.ctaImageWrapper}
                    image={image}
                    gridSize={gridSize}
                />
            </div>
        </SectionContainer>
    );
}

export { CallToAction };
